import { createSmartrrModal } from "@vendor-app/utils/createModalStore";

export const useEditAddressModalErrorStore = createSmartrrModal();
